<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h5>Rangos de cuotas</h5>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__content">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Descripción</th>
                    <th>Desde</th>
                    <th>Hasta</th>
                    <th>Valor</th>
                    <th>Comisión</th>
                    <th>
                      <div>
                        <button @click="agregar" class="btn-success">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(rango, index) in form.rangos"
                    is="tr-rango"
                    v-model="form.rangos[index]"
                    @eliminar="eliminarRango"
                    :key="index + moment(new Date()).format('YYYYMMDDHHmmss')"
                  ></tr>
                  <tr v-show="form.rangos.length === 0">
                    <td colspan="5">
                      <strong>No se ha agregado rango alguno.</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button type="button" @click="guardar" class="btn-success">
              <i class="fa fa-save"></i><span>Guardar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrRango from "./TrRango.vue";
export default {
  components: {
    TrRango,
  },
  props: {
    rangos: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    eliminarRango: function (index) {
      this.form.rangos.splice(index, 1);
    },
    agregar: function () {
      this.form.rangos.push({
        descripcion: "",
        desde: "",
        hasta: "",
        valor: "",
      });
    },
    guardar: function () {
      axios
        .post(url + "/rangos-cuotas", this.form)
        .then(() => {
          swal("Los rangos han sido almacenados.", "Realizado", "success");
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
  },
  data: function () {
    return {
      moment: moment,
      form: {
        rangos: this.rangos,
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/general/RangosCuotas.vue